import { Link } from 'react-router-dom';
import React, { Component } from 'react';

import { PATHS, CatalogHeaders, ErrorMessages, CatalogDummyData } from '../../common/constants';

import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import Icon from '../Icon';
import ItemForm from '../ItemForm';
import Overlay from '../Overlay';
import Table, { Hidden } from '../Table';
import Search from '../Search';
import { setItemFormData, clearItemFormData } from '../../store/actions/itemForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectSearch } from '../../store/selectors/search';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { CSVLink } from 'react-csv';
import CSVUpload from '../CSVUpload/CSVUpload';
import { ToastInfo } from '../../helpers/validationHelper';
import { selectValidation } from '../../store/selectors/Validation';
import ItemsResponsePopup from './ItemsResponsePopup';
import { clearValidation } from '../../store/actions/validation';
import { onClearResponseDone } from '../../store/actions/suites';

class ItemsTable extends Component {
  state = {
    showOverlay: false,
  };

   /*
      Modified By: Sai Prasad
      Modified Date: 01/09/2022
      Jira Ticket: JUN-2692
      Description: capturing csv uploaded catalog data.
  */
  fetchCatalogDataFromCSV = (result) => {
    const { onSaveBulkImport } = this.props;
    let propArray =[];  
    if(result && result.length > 0) { 
      result = result.filter(obj => (Object.keys(obj).includes("Name") && Object.keys(obj).includes("Type")));
      if(result && result.length > 0) {
      let findEmptyData = result.filter(item => !item.Name?.trim() || !item.Type?.trim() || !item.Warranty?.trim() || !item.Properties?.trim())
        if(findEmptyData && findEmptyData.length === 0) {
          const updatedResult =  result.map(item => {        
            if(item.Properties && item.Properties.length > 0) {
              propArray = item.Properties.split('&');
              propArray = propArray.filter(function (el) {return el.trim() != "";});
              propArray = propArray.map(prop => {return {name: prop}});
              return {...item, Properties: propArray}
            } else {
              return {...item, Properties: []}
            }
          })
          onSaveBulkImport(updatedResult);
        } else {
          ToastInfo(ErrorMessages.csvValidation)
        }
      } else {
        ToastInfo(ErrorMessages.csvValidation)
      }
    } else {
      ToastInfo(ErrorMessages.noDatacsv);
    }
  }

  /*
      Modified By: Sai Prasad
      Modified Date: 01/09/2022
      Jira Ticket: JUN-3153
      Description: function to clear response and validation .
  */ 
  clearItemsImportResponse = () => {
    const { onClearValidation, onClearResponse } = this.props;
    onClearValidation();
    onClearResponse();
}

  render() {
    const { items, onSaveItem, onDeleteItem,onSearch,setItemFormData,clearItemFormData, search, loader, itemsResponse, validation } = this.props;
    const { showOverlay } = this.state;
    return (
      <>
        {loader ? <Loader center={true}/> : null}
        <Actions compact>
        <div className="searchbar serviceRequestsSearch">
          <Search
            size="small"
            placeholder="Search Items..."
            onChange={onSearch}
          />
          {this.props.user.roles[0].role.name === "Strata Manager" ? null : (
               /*
                    Modified By: Sai Prasad
                    Modified Date: 26/08/2022
                    Jira Ticket: JUN-2692
                    Description: csv download and upload scv buttons added.
                */
            <>
                      <div className='button-right' style={{paddingTop: 7}} title='Download CSV template'>
                      <CSVLink
                        data={CatalogDummyData}
                        headers={CatalogHeaders}
                        filename="Items.csv"
                        ref={this.csvLink}
                        target="_blank"
                      >
                        <Icon glyph="download" weight="regular" size="big" />
                        </CSVLink>
                        </div>
                        <div className='button-right'>
                       <CSVUpload onFetchData={this.fetchCatalogDataFromCSV} buttonName='Bulk Items Import'/>
                       </div>
                       <div className='button-right'>
          <Button
            color="teal"
            label="Add Item"
            onClick={() => {
              setItemFormData({
                name:'',
                model:'',
                makeName:'',
                typeName:'',
                warrantyYears:''

              })
              this.setState({ showOverlay: true })}}
            icon={(
              <Icon
                glyph="boxes"
                weight="light"
                size="small"
              />
            )}
            size="small"
          /></div></>)}
          </div>
        </Actions>
        {items.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Item',
                  sortable: true,
                  accessor: 'name',
                  cell: data => (
                    <Link
                    to={{
                      pathname:PATHS.ITEMS_VIEW.replace(':id', data.id),
                      state:{item:data}
                    }}
                    >
                      {data.name}
                    </Link>
                  )

                }, {
                  label: 'Make',
                  // accessor: 'makeName',
                  cell: data => data && data.makeName ? data.makeName : '—'
                }, {
                  label: 'Model',
                  // accessor: 'model',
                  cell: data => data && data.model ? data.model : '—'
                }, {
                  xsHide: true,
                  label: 'Type',
                  accessor: 'typeName'
                }, {
                  center: true,
                  xsHide: true,
                  label: 'Warranty Plan',
                  cell: data => data.warrantyYears === "0" ? "NA" :(`${data.warrantyYears} year${data.warrantyYears > 1 ? 's' : ''}`)
                },{
                  center: true,
                  xsHide: true,
                  label: 'Property',
                  cell: data => 
                  <div className="title_elipse" 
                  title={data.properties  && data.properties.length > 0 &&
                    data.properties.map((ps, index) => {
                      return (
                        ps.name + (data.properties.length-1 === index ? '' : ', ')
                      )
                    })}>
                      {data.properties  && data.properties.length > 0 &&
                      data.properties.map((ps, index) => {
                        return (
                          ps.name + (data.properties.length-1 === index ? '' : ', ')
                        )
                      })}
                      </div>                    
                },
                 {
                  // xsHide: true,
                  cell: data => this.props.user.roles[0].role.name === "Strata Manager" ? null : (
                    <Hidden>
                      <Button
                        color="semantic"
                        label={(
                          <Icon
                            glyph="pencil"
                            weight="light"
                          />
                        )}
                        onClick={() => {
                        this.setState({ showOverlay: true})
                          setItemFormData({...data, selectedProperties : data.properties.map(pty => ({value : pty.id, label: pty.name}))})
                        }}
                      />
                      <Button
                        color="semantic"
                        onClick={() => window.confirm(`Are you sure you want to delete ${data.name}?`)&& onDeleteItem(data)}
                        label={(
                          <Icon
                            glyph="trash"
                            weight="light"
                          />
                        )}
                      />
                    </Hidden>
                  )
                }
              ]}
              data={items}
            />
          </>
        ) : (
          <Empty
            direction="ttb"
            headline="Add items to your catalog"
            strapline="Keep all your contacts you here so it’s easier for you to manage."
            searchIsActive={search && search.items ? search.items : ''}
            cta={this.props.user.roles[0].role.name === "Strata Manager" ? null : (
              <Button
                color="teal"
                label="Add Item"
                onClick={() => {
                  setItemFormData({
                    name:'',
                    model:'',
                    makeName:'',
                    typeName:'',
                    warrantyYears:''

                  })
                  this.setState({ showOverlay: true })}}
                icon={(
                  <Icon
                    glyph="boxes"
                    weight="light"
                    size="small"
                  />
                )}
                size="small"
              />
            )}
            image={(
              <img
                alt="Add items to your catalog"
                src="/assets/empty/items.svg"
              />
            )}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={(
            <ItemForm
              onClose={() => this.setState({ showOverlay: false },()=> clearItemFormData())}
              onSaveItem={onSaveItem}
            />
          )}
        />
        {/*
          Created By: Sai Prasad
          Created Date: 26/08/2022
          Jira Ticket: JUN-3153
          Description: imported ItemsResponsePopup component to show response to user.
        */}
         {validation.status === true && validation.message === "Items Imported" && itemsResponse.length > 0 &&
        <ItemsResponsePopup data={itemsResponse} onPress={this.clearItemsImportResponse}/>}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  search: selectSearch(state),
  loader: selectFormLoader(state),
  validation: selectValidation(state),
  itemsResponse: state.responseStore.itemsImport
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setItemFormData,
  clearItemFormData,
  onClearValidation: clearValidation,
  onClearResponse: onClearResponseDone
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemsTable);
